export class EventInfo{
    eventUUID: string
    eventTitle: string
    eventSubtitle: string
    eventDate: string
    ticketAmount: number
}


// WEBPACK FOOTER //
// ./src/app/models/event-info.model.ts